import _defineProperty from "/var/lib/jenkins/workspace/workspace/mr-learner-frontend-production-china/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

// ========================= Placeholder ==========================
var genEmptyStyle = function genEmptyStyle(token) {
  var componentCls = token.componentCls;
  return _defineProperty({}, "".concat(componentCls, "-wrapper"), _defineProperty({}, "".concat(componentCls, "-tbody > tr").concat(componentCls, "-placeholder"), _defineProperty({
    textAlign: 'center',
    color: token.colorTextDisabled
  }, "\n          &:hover > th,\n          &:hover > td,\n        ", {
    background: token.colorBgContainer
  })));
};

export default genEmptyStyle;